import React, { useState } from 'react';
import { isUndefined } from 'lodash-es';
import { usePrevious } from 'site-modules/shared/hooks/use-previous';

export const withOverviewCtaDataAdapter = WrappedComponent => {
  function OverviewCtaDataAdapter(props) {
    const { trimSummary: trimSummaryProp, leadFormDealerCount: leadFormDealerCountProp, ...rest } = props;

    const [trimSummary, setTrimSummary] = useState(trimSummaryProp);
    const [leadFormDealerCount, setLeadFormDealerCount] = useState(leadFormDealerCountProp);
    const prevTrimSummaryProp = usePrevious(trimSummaryProp);
    const prevLeadFormDealerCountProp = usePrevious(leadFormDealerCountProp);

    if (prevTrimSummaryProp !== trimSummaryProp) {
      if (!isUndefined(trimSummaryProp)) setTrimSummary(trimSummaryProp);
    }

    if (prevLeadFormDealerCountProp !== leadFormDealerCountProp) {
      if (!isUndefined(leadFormDealerCountProp)) setLeadFormDealerCount(leadFormDealerCountProp);
    }

    return <WrappedComponent trimSummary={trimSummary} leadFormDealerCount={leadFormDealerCount} {...rest} />;
  }

  OverviewCtaDataAdapter.displayName = `withOverviewCtaDataAdapter(${WrappedComponent.displayName || WrappedComponent.name})`;

  return OverviewCtaDataAdapter;
};
